import apiClient from '@/services/api-client';

export const findNotifications = async (params) => {
  const response = await apiClient.get('/notification/in-site', {
    params: params
  });

  return response.data;
};
